export { default as WalletInput } from './WalletInput'
